import { app } from '../../../../../app';
import { Controller } from './group-custom-attributes.controller';

app.component('companyUserDirectoriesManageGroupCustomAttributes', {
    bindings: {
        companyId: '<',
        group: '<',
        customAttributes: '<',
    },
    controller: Controller,
    templateUrl: require('./group-custom-attributes.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-group/custom-attributes/group-custom-attributes.component.js